import React from 'react'

export default function Message({ text }) {
    return (
        <div className="message">
            {text}
        </div>
    )
}
